// extracted by mini-css-extract-plugin
module.exports = {"termsContainer":"styles_termsContainer__1uuVd","termsTitle":"styles_termsTitle__1-Fvj","terms":"styles_terms__2nD5r"};